import React, { useState } from 'react';
import Button3D from '../../ui/Button3D';
import Switch from '../../ui/Switch';
import { settingsSubtitle } from '../eventSettings';
import { resolveEventWords } from '../eventWords';
import SettingsPopup from './SettingsPopup';

function ToggleRow({ id, label, checked, onChange, note }) {
    return (
        <li className="ia-resv-field ia-resv-field--wide" data-testid={`toggle-${id}`}>
            <div className="flex items-center justify-between gap-3">
                <span id={`${id}-label`} className="text-sm font-bold">{label}</span>
                <Switch id={id} checked={checked} onChange={onChange} aria-label={label} describedBy={`${id}-note`} />
            </div>
            <p id={`${id}-note`} className="ia-resv-field__why">{note}</p>
        </li>
    );
}

// Module 19 (BL-380) G6 - "Hotel & Travel": whether events show a hotel block, and whether the guest list asks about the shuttle.
// Turning either off hides it everywhere; nothing already stored is deleted, so turning it back on brings it all back.
export default function HotelTravelSettingsPopup({ settings, saving, error, onSave, onClose }) {
    const [form, setForm] = useState({ hotel_block_enabled: settings.hotel_block_enabled !== false, shuttle_enabled: settings.shuttle_enabled !== false });
    const words = resolveEventWords(settings);
    const flip = (name) => (value) => setForm((previous) => ({ ...previous, [name]: value }));
    const submit = (event) => { event?.preventDefault?.(); onSave({ ...settings, ...form }); };
    return (
        <SettingsPopup
            title="Hotel & Travel"
            subtitle={settingsSubtitle(words)}
            tileKey="hotel-travel"
            testId="events-settings-hotel"
            onClose={onClose}
            actions={(
                <>
                    <Button3D onClick={onClose} disabled={saving}>Cancel</Button3D>
                    <Button3D variant="go" onClick={submit} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button3D>
                </>
            )}
        >
            <form onSubmit={submit} noValidate>
                <ul className="ia-resv-grid" aria-label="Hotel and travel">
                    <ToggleRow id="set-hotel" label="Hotel block" checked={form.hotel_block_enabled} onChange={flip('hotel_block_enabled')}
                        note={`Each ${words.eventLower} can have one hotel block: hotel, dates, rate, booking link and cut-off date. Guests see it on their page when that arrives.`} />
                    <ToggleRow id="set-shuttle" label="Ask about the shuttle" checked={form.shuttle_enabled} onChange={flip('shuttle_enabled')}
                        note="Mark the guests who need the shuttle (by hand or in the import) and see how many. Shuttle trips are planned later; nothing is booked now." />
                </ul>
                <p className="mt-3 text-sm">Turning one off hides it. Nothing already saved is deleted.</p>
                {error && <p className="ia-resv-error" role="alert">{error}</p>}
            </form>
        </SettingsPopup>
    );
}
